<style lang="scss" scoped>
.advanced-search {
	&__form {
		width: 100%;
	}
	&__button {
		margin-top: 24px;
		button {
			width: 100%;
		}
	}
}
</style>

<template lang="pug">
    .advanced-search
        el-form.advanced-search__form(ref='form' :model='form' label-width='120px', label-position="top", size="medium", @submit.native.prevent="handleSubmit")
            el-row(:gutter='10')
                el-col(:span='12')
                    el-form-item(label='School name')
                        el-input(v-model="form.name", ref="autofocus", placeholder="School name")
                el-col(:span='12')
                    el-form-item(label='MIS')
                        el-select(v-model='form.mis_id' placeholder='Select MIS', :clearable="true", :loading="$apollo.loading")
                            el-option(v-for='mis in Mis', :key='mis.id', :label='mis.nice_name', :value='mis.id')
            el-row(:gutter='10')
                el-col(:span='12')
                        el-form-item(label='Phase of education')
                            el-input(placeholder="eg. Primary, Secondary etc" v-model="form.phase_of_education")
                //- el-col(:span='12')
                //-     el-form-item(label='State/Province')
                //-         el-input(v-model="form.address_state", placeholder='Enter state/province')
                el-col(:span='12')
                    el-form-item(label='Country')
                        el-select(v-model='form.country_id' placeholder='Select country', clearable, filterable, :loading="$apollo.loading")
                            el-option(v-for='country in Countries', :key='country.id', :label='country.name', :value='country.id')
            el-row(:gutter='10')
                el-col(:span='12')
                    el-form-item(label='Post code')
                        el-input(v-model="form.address_postcode", placeholder='Enter post code')
            el-row.advanced-search__button(:gutter='10')
                el-col(:span='24')
                    el-button(type="primary", icon="el-icon-search", :disabled="disabled", :loading="state == 'loading'", native-type="submit") {{ state == 'loading' ? 'Searching' : 'Search'}}
</template>

<script>
import gql from "graphql-tag";
import MisQuery from "@/graphql/queries/Mis";
import CountriesQuery from "@/graphql/queries/Countries";
import { sortBy } from "lodash";

export default {
	name: "AdvancedSearch",
	props: {
		associatedOnly: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		this.$nextTick(function() {
			this.$refs.autofocus.$el.children[0].focus();
		});
	},
	data: () => ({
		state: "ready",
		form: {
			name: "",
			mis_id: "",
			phase_of_education: "",
			address_postcode: "",
			address_state: ""
		}
	}),
	computed: {
		disabled() {
			return Object.values(this.form).every(v => v === "");
		}
	},
	methods: {
		async handleSubmit() {
			this.state = "loading";
			try {
				const results = await this.$apollo.query({
					query: gql`
						query AdvancedSchoolSearch($attributes: AdvancedSearchAttributes, $associated: Boolean) {
							AdvancedSchoolSearch(attributes: $attributes, associated: $associated) {
								id
								name
								address_postcode
								urn
								la_code
								establishment_number
								country_iso_3166_2
								country_name
								phase_of_education
							}
						}
					`,
					variables: {
						attributes: this.form,
						associated: this.associatedOnly
					}
				});

				this.$bus.$emit("search-results", results.data.AdvancedSchoolSearch);
				this.state = "loaded";
			} catch (err) {
				this.state = "ready";
			}
		}
	},
	apollo: {
		Mis: {
			query: MisQuery,
			variables: {
				installed: true
			},
			update: r => sortBy(r.Mis, "nice_name")
		},
		Countries: {
			query: CountriesQuery,
			update: r => sortBy(r.Countries, "name")
		}
	}
};
</script>
